(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-reccomendations"] && !Shopify.designMode) return;
  try {
    
  const productRecommendationsSection = document.querySelector('section.recommendations');

  const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
          .then(response => response.text())
          .then(text => {
              const html = document.createElement('div'); 
              html.innerHTML = text;
              const recommendations = html.querySelector('.recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                  productRecommendationsSection.innerHTML = recommendations.innerHTML;
                  document.dispatchEvent(new CustomEvent('recommendationsLoaded'));
              }
              console.log('Recommendations loaded');
              intObs();
          })
          .catch(e => {
              console.error(e);
          });
  };

  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();
})();
